import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import { usePurchaseOrderApi } from '../../../../store/api/hooks/purchaseOrderApiHook';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import FileUpload from '../../../../components/elements/form/fileUplaod';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import CreatePurchaseOrderParts from './createPurchaseOrderParts';
import CreatePurchaseOrderAssets from './createPurchaseOrderAssets';
import moment from 'moment';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Icon from '../../../../components/icons';
import { useVendorsApi } from '../../../../store/api/hooks/vendorsApiHook';

interface Props {
    _ref?: any;
    PoID?: any;
    onCreate?: () => void;
    onCancel?: () => void;
}

const CreatePurchaseOrder: React.FC<Props> = ({ _ref, PoID = null, onCreate = () => { }, onCancel = () => { } }) => {
    const assetApi: any = useAssetsApi();
    const purchaseApi = usePurchaseRequestApi();
    const purchaseOrderAPI = usePurchaseOrderApi();
    const facilityApi = useFacilitiesApi();
    const user: any = useUserSelector();

    const [vendorlist, setvendorList] = useState<any>([]);
    const [poTypes, setPOTypes] = useState<any>([]);

    const [lineItems, setLineItems] = useState<any>([]);
    const [lineItemMode, setLineItemMode] = useState<'parts' | 'assets' | null>(null);
    const [tax, setTax] = useState<any>(null);
    const [savedattachments, setSavedAttachments] = useState<any>([]);
    const vendorsApi = useVendorsApi();
    const [departmentList, setDepartmentList] = useState<any>(null);

    // Initialize form methods

    const { control, reset, handleSubmit, setValue, watch, trigger, getValues, formState: { errors } } = useForm<any>();
    const [poDetails, setPODetails] = useState<any>(null);

    const vendorWatch = watch('vendorID');

    const getCode = () => {
        const payload = {};
        purchaseOrderAPI.getOrderCode(payload, (resp: any) => {
            setValue('code', resp.code);
        }, (error: any) => {

        });
    };

    const GetDepartmentList = () => {
        const payload = {pageSize: 5000,
                pageNumber: 1,};
        assetApi.getAssetdepartment(payload, (resp: any) => {
          let deptlist: any = [];
          //console.log("resp", resp);
          resp.departmentsList.map((department: any) => {
            deptlist.push({
              label: department.departmentName,
              value: department.departmentID,
            });
          });
          setDepartmentList(deptlist);
        }, (error: any) => {
          console.log("error =>", error);
          setDepartmentList([]);
          toast.error(error);
        });
      };

    /* const getVendorList = () => {
        const payload = {};
        assetApi.GetvenderList(
            payload,
            (resp: any) => {
                let deptlist: any = [];

                resp.vendorList.map((facilist: any) => {
                    deptlist.push({
                        label: facilist.name,
                        value: facilist.vendorID,
                    });
                });
                setvendorList(deptlist);
            },
            (error: any) => {
            }
        );
    }; */
    const getVendorList = () => {
        const payload = {
            vendorServiceTypeIDs: [6],
            searchParam: ``
        };
        vendorsApi.FilteredServiceProviderList(
            payload,
            (resp: any) => {
                if (resp && resp.hasOwnProperty(`successful`) && resp.successful && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
                    let vendorlist: any = [];

                    resp.vendorList.map((vendor: any) => {
                        vendorlist.push({
                            label: vendor.name,
                            value: vendor.vendorID,
                        });
                    });
                    setvendorList(vendorlist);
                }
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getPOTypes = () => {
        const payload = {};
        purchaseApi.GetPurchaseRequestTypeList(
            payload,
            (resp: any) => {
                setPOTypes(resp.purchaseRequestTypeList.map((item: any) => {
                    return {
                        label: item.prTypeName,
                        value: item.prTypeID
                    };
                }));
            },
            (error: any) => {
            }
        );
    };

    const loadFacilities = (inputValue: string): Promise<any[]> => {
        return new Promise<any[]>((resolve) => {
            facilityApi.getFacilityList({
                pageSize: 10,
                pageNumber: 1,
                searchParam: inputValue,
            }, (resp: any) => {
                resolve(resp.facilityList.map((item: any) => {
                    return {
                        label: item.facilityName,
                        value: item.facilityID,
                    } as Option;
                }));
            }, (error: any) => {
                resolve([]);
            });
        });
    };

    const poTypeWatch = watch('poType');


    const onSubmit = (data: any) => {
        let payload: any = {
            purchaseOrderCode: data.code,
            facilityID: data.facilityID.value,
            subFacilityID: null,
            vendorID: data.vendorID.value,
            taxID: tax ? tax.value : null,
            purchaseOrderTypeID: data.poType.value,
            purchaseOrderStatusID: data.draft ? 1 : 2, // 1 for Draft, 2 for Pending Approval
            requesterID: user?.userID || 0,
            requiredByDate: moment(data.dueDate).format('YYYY-MM-DD'),
            notes: data.notes,
            purchaseRequestID: null,
            departmentID: data.departmentID ? data.departmentID.value : null,
            //"reason": "string",
            /* "purchaseOrderDetails": [
                {
                    "partsID": 0,
                    "vendorID": 0,
                    "requiredQty": 0,
                    "unitID": 0,
                    "totalAmount": 0
                }
            ],
            "purchaseOrderPurchaseRequest": [
                {
                    "purchaseRequestID": 0
                }
            ],
            "purchaseOrderAsset": [
                {
                    "assetName": "string",
                    "vendorID": 0,
                    "unitID": 0,
                    "requiredQty": 0
                }
            ] */
        };
        if (PoID) {
            payload.purchaseOrderID = PoID;
        }
        if (poDetails && poDetails.hasOwnProperty(`purchaseRequestID`) && poDetails.purchaseRequestID) {
            payload.purchaseRequestID = poDetails.purchaseRequestID;
        }
        if (data.poType.value == 1) {
            payload.purchaseOrderDetails = lineItems.map((item: any) => {
                return {
                    partsID: item.partsID,
                    vendorID: item.vendorID,
                    requiredQty: item.requiredQty,
                    unitID: item.unitID,
                    unitPrice: item.unitPrice,
                    totalAmount: Number((item.requiredQty * item.unitPrice).toFixed(2))
                };
            });
        }
        if (data.poType.value == 2 || data.poType.value == 3) {
            payload.purchaseOrderAsset = lineItems.map((item: any) => {
                return {
                    //assetID: item.assetID,
                    assetName: item.assetName,
                    vendorID: item.vendorID,
                    unitID: item.unitID,
                    unitPrice: item.purchaseCost,
                    requiredQty: item.requiredQty,
                    totalAmount: Number((item.requiredQty * item.purchaseCost).toFixed(2))
                };
            });
        }

        if (lineItems.length == 0) {
            toast.error('Please add at least one line item');
            return;
        } else {
            let missingValues = false;
            lineItems.forEach((item: any) => {
                if (!item.requiredQty) {
                    missingValues = true;
                }
            });
            if (missingValues) {
                toast.error('Please fill all required fields in line items');
                return;
            }
        }

        purchaseOrderAPI.saveOrder(payload, (resp: any, message: string) => {
            console.log('Purchase Order saved successfully', resp);
            toast.success(message || 'Purchase Order saved successfully');
            console.log('on save reset line items');
            setLineItems([]);
            console.log('Purchase Order ID:', resp.returnID);
            console.log('files', data.files);
            if (data.files && data.files.length > 0) {
                console.log('Uploading files for Purchase Order ID:', resp.returnID, data.files);
                // Handle file uploads
                const formData = new FormData();
                let i = 0;
                formData.append('purchaseOrderID', resp.returnID || PoID);
                for (const partattchment of data.files) {
                    formData.append("InputFile" + i, partattchment);
                    i++;
                }

                purchaseOrderAPI.savePurchaseOrderFile(formData, (fileResp: any) => {
                    console.log('Files uploaded successfully', fileResp);
                    toast.success('Files uploaded successfully');
                    onCreate();
                }, (error: any) => {
                    console.error('Error uploading files', error);
                    toast.error('Error uploading files');
                });
            } else {
                onCreate()
            }
            getCode();

        }, (error: any) => {
            console.error('Error saving Purchase Order', error);
        });
        console.log('payload', payload);
    }

    useEffect(() => {
        console.log('on poTypeWatch reset line items');
        setLineItems([]);
        if (poTypeWatch?.value == 1) {
            setLineItemMode('parts');
        } else if (poTypeWatch?.value == 2 || poTypeWatch?.value == 3) {
            setLineItemMode('assets');
        } else {
            setLineItemMode(null);
        }
    }, [poTypeWatch]);

    useEffect(() => {
        console.log('lineItems', lineItems);
    }, [lineItems]);

    useEffect(() => {
        getCode();
        getVendorList();
        getPOTypes();
        GetDepartmentList();
    }, []);
    useEffect(() => {
        if (PoID) {
            purchaseOrderAPI.getOrderById({ purchaseOrderID: PoID }, (resp: any) => {
                console.log('Purchase Order Details:', resp);
                setPODetails(resp);
                reset({
                    code: resp.purchaseOrderCode,
                    vendorID: resp.vendorID ? { label: resp.vendorName, value: resp.vendorID } : null,
                    dueDate: moment.utc(resp.requiredByDate).local().toDate(),
                    poType: resp.typeID ? { label: resp.typeName, value: resp.typeID } : null,
                    facilityID: resp.facilityID ? { label: resp.facilityName, value: resp.facilityID } : null,
                    departmentID: resp.departmentID ? { label: resp.departmentName, value: resp.departmentID } : null,
                    notes: resp.notes || '',
                    files: [],
                    draft: false,
                    tax: resp.taxID ? { label: resp.taxRateName, value: resp.taxID, rate: +resp.taxRate } : null,
                });
                console.log("resp.taxID ? { label: resp.taxRateName, value: resp.taxID } : null", resp.taxID ? { label: resp.taxRateName, value: resp.taxID } : null)
                purchaseOrderAPI.getFiles({ PurchaseOrderID: PoID }, (filesResp: any) => {
                    console.log('Files for Purchase Order:', filesResp);
                    if (filesResp && filesResp.code === 200 && filesResp.hasOwnProperty(`successful`) && filesResp.successful === true && Array.isArray(filesResp.purchaseOrderAttachmentList) && filesResp.purchaseOrderAttachmentList.length > 0) {
                        console.log("Exec yeah");
                        setSavedAttachments(filesResp.purchaseOrderAttachmentList)
                    }
                }, (error: any) => {
                    console.error('Error fetching files for Purchase Order', error);
                });

                setTax(resp.taxID ? { label: resp.taxRateName, value: resp.taxID, rate: +resp.taxRate } : null);
                console.log('resp=============', resp?.typeID);
                if (resp?.typeID === 1) {
                    setLineItemMode('parts');
                    const items = resp?.purchaseOrderItemList.map((o: any) => ({
                        partsID: o.partsID,
                        vendorPartCode: o.partsCode,
                        vendorPartName: o.partName,
                        vendorID: o.vendorID,
                        vendorName: o.vendorName,
                        requiredQty: o.requiredQty,
                        unitID: o.unitID,
                        unitPrice: o.unitPrice,
                        unitName: o.unitCode,
                        totalAmount: o.totalAmount,
                    }));
                    console.log('items', items);
                    setLineItems(items);
                    setTimeout(() => { setLineItems(items); }, 1000);


                } else if (resp?.typeID === 2 || resp?.typeID === 3) {
                    setLineItemMode('assets');
                    const bind_pritemlist = resp?.purchaseOrderAsset.map((o: any) => {
                        return {
                            assetID: o.assetID,
                            assetName: o.assetName,
                            vendorID: o.vendorID,
                            vendorName: o.vendorName,
                            unitID: o.unitID,
                            purchaseCost: +o.unitPrice || 0,
                            unitCode: `Each`,
                            totalAmount: (+o.unitPrice || 0) * +o.requiredQty,
                            requiredQty: +o.requiredQty,
                            isEdit: false
                        }
                    });
                    setLineItems(bind_pritemlist);
                    setTimeout(() => { setLineItems(bind_pritemlist); }, 1000);

                } else {
                    setLineItemMode(null);
                }
            }, (error: any) => {
                console.error('Error fetching Purchase Order details', error);
            });
        }
    }, [PoID]);

    const resetForm = () => {
        console.log('on reset form reset line items');
        reset({
            code: '',
            vendorID: null,
            dueDate: null,
            poType: null,
            facilityID: null,
            departmentID: null,
            notes: '',
            files: [],
            draft: false,
        });
        setLineItems([]);
        setLineItemMode(null);
        setTax(null);
        getCode();
    };


    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = resetForm;
        }
    }, [_ref]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className='flex flex-col h-full' noValidate>
            <div className='flex-1 overflow-auto'>
                <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Basic Information</h4>
                <Controller
                    name='code'
                    control={control}
                    rules={{ required: 'PO Number is required' }}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label='PO Number'
                            type='text'
                            disabled={true}
                            value={value}
                            onChange={onChange}
                            placeholder='Write PO Number'
                        />
                    )}
                />
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name="vendorID"
                        control={control}
                        rules={{ required: 'Select Vendor Name' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Vendor"
                                value={value}
                                onChange={onChange}
                                placeholder="Choose Vendor Name"
                                className="mt-0"
                                required
                                options={vendorlist}
                                error={errors.vendorID?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name="dueDate"
                        control={control}
                        rules={{ required: 'Due Date is required' }}
                        render={({ field: { value, onChange } }) => (
                            <Datepicker
                                label="Due Date"
                                value={value}
                                onChange={onChange}
                                minDate={new Date()}
                                className='mt-0'
                                required
                                error={errors.dueDate?.message as any}
                            />
                        )}
                    />
                </div>

                <Controller
                    name='poType'
                    control={control}
                    rules={{ required: 'PO Type is required' }}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='PO Type'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Write PO Type'
                            options={poTypes}
                            className='mb-0'
                        />
                    )}
                />
                
                {/* Conditionally render Department dropdown only for PO Type 1 or 2 */}
                {(poTypeWatch?.value === 1 || poTypeWatch?.value === 2) && (
                    <Controller
                        name="departmentID"
                        control={control}
                        rules={{ required: "Department is required" }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label="Department"
                                value={value}
                                onChange={onChange}
                                required
                                placeholder="Select"
                                options={departmentList ? departmentList : []}
                                error={errors.departmentID?.message as any}
                            />
                        )}
                    />
                )}



                {(() => {
                    if (lineItemMode === `parts`) {
                        return (
                            <CreatePurchaseOrderParts VendorID={vendorWatch?.value || null} data={lineItems} onUpdate={setLineItems} onSetTax={setTax} savedtax={tax} />
                        )
                    }
                    if (lineItemMode === `assets`) {
                        return (
                            <CreatePurchaseOrderAssets data={lineItems} onUpdate={setLineItems} onSetTax={setTax} savedtax={tax} />
                        )
                    }
                })()}




                <Controller
                    name='files'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <FileUpload
                            label="Attach Files"
                            value={value}
                            isMulti={true}
                            accept=".jpg, .jpeg, .png, application/pdf, .pdf"
                            isFigmaType={true}
                            className={`mb-3.5`}
                            //allowedExt={[`png`, `jpg`, `jpeg`, `gif`]}
                            retainFiles={true}
                            onChange={(e: any, files: any) => {
                                console.log(e, 'files', files);
                                setValue('files', files);
                                //onChange(files);
                            }}
                            placeholder="Choose Files"
                        />
                    )}
                />
                {savedattachments && savedattachments.length > 0 && (
                    <div className={`mb-4`}>
                        <h4 className="font-semibold text-[0.938rem] pb-3 uppercase">Files</h4>
                        <div className="grid grid-cols-5 gap-3">
                            {savedattachments.map((item: any, index: number) => {
                                const found = [`.png`, `.jpg`, `.jpeg`, `.webp`, `.pdf`, `.doc`, `.xls`, `.docx`, `.xlsx`].some((word) =>
                                    item.originalFileName.includes(word)
                                );
                                return (
                                    <div key={`attachmentList${index}`} className={`border border-primary rounded-md flex px-0 py-0 text-[0.813rem] text-primary text-center justify-center items-center relative`}>
                                        <Link to={item.fullFilePath} target="_blank">
                                            {found ? (
                                                <img src={item.fullFilePath} alt={item.originalFileName} className={`max-w-full max-h-20`} />
                                            ) : (
                                                <div className={`h-6 w-5 flex items-center justify-center`}><Icon name={`attachmentfile`} size={1.3} /></div>
                                            )}
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}



                <h4 className='font-semibold text-[0.938rem] pt-4 pb-0 uppercase'>Receiving Store</h4>
                <Controller
                    name='facilityID'
                    control={control}
                    rules={{ required: 'Search and Select Facility' }}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            async={true}
                            isClearable
                            label='Select Facility'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Type to search facilities'
                            asyncLoadOptions={loadFacilities}
                            className='mb-0'
                            error={errors.facilityID?.message as any}
                        />
                    )}
                />



                <Controller
                    name='notes'
                    control={control}
                    /*rules={{ required: 'Notes are required' }}*/
                    render={({ field: { value, onChange } }) => (
                        <Teaxtarea
                            label='Notes'
                            value={value}
                            onChange={onChange}
                            /*required*/
                            required={false}
                            placeholder='Notes'
                        /*error={errors.notes?.message as any}*/
                        />
                    )}
                />
            </div>
            <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                <Button theme='secondary' working={false} onClick={onCancel}>Cancel</Button>
                <Button working={false} onClick={() => {
                    trigger().then((isValid) => {
                        if (isValid) {
                            onSubmit({ ...getValues(), draft: true });
                        } else {
                            console.log('Form is invalid');
                        }
                    })
                }}>Save</Button>
                <Button type="submit">Send for Approval</Button>

            </div>

        </form>
    );
};


export default CreatePurchaseOrder;